module.exports = __webpack_public_path__ + "static/media/T14.a5f84733.png";